import React, { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/store';
import { changeEnter } from 'src/utils/changeEnter';

const RatingAnswerSurvey: FC = () => {
  const currentIndex = useSelector(
    (state: any) => state.imageUpload.currentIndex
  );
  const text = useSelector((state: RootState) => state.editText.text);
  const btnText = useSelector((state: RootState) => state.buttons.btnText);

  const [selectedStar, setSelectedStar] = useState(-1);

  return (
    <>
      <div className="root_view">
        <div className="template">
          <div className="center_horizon close">
            <button />
          </div>
          <div className="center_wrapper">
            <div className="logo">
              <button />
            </div>
            <div className="title">
              <div className="title_inner">
                {changeEnter(text?.title?.[currentIndex])}
              </div>
            </div>
            <div className="sub_title">
              <div className="sub_title_inner">
                {changeEnter(text?.sub_title?.[currentIndex])}
              </div>
            </div>
            <div className="star_wrapper">
              {[...Array(5)].map((_, idx) => (
                <div
                  className={`star_inner ${idx <= selectedStar && 'action'}`}
                  onClick={() => {
                    if (idx === 0 && selectedStar === 0) setSelectedStar(-1);
                    else setSelectedStar(idx);
                  }}
                >
                  <button />
                </div>
              ))}
            </div>
          </div>
          <div className="center_horizon bottom">
            <button className={`button ${selectedStar >= 0 && 'action'}`}>
              {btnText?.button?.[currentIndex]}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};
export default RatingAnswerSurvey;
